module.exports = __webpack_public_path__ + "img/img-1.d7e4e760.jpg";